import { render } from "./CustomerListTable.vue?vue&type=template&id=597d2e56&scoped=true"
import script from "./CustomerListTable.vue?vue&type=script&lang=js"
export * from "./CustomerListTable.vue?vue&type=script&lang=js"

import "./CustomerListTable.vue?vue&type=style&index=0&id=597d2e56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597d2e56"]])

export default __exports__